/**
 * @type {number|boolean}
 */
const t0 = window.performance ? performance.now() : false;

/**
 * Use this to js execution time.
 * We track the result in GA
 *
 * @return {string[]} returns the value to be tracked
 *
 * @example
 * jsExecute()
 * // 100 milliseconds
 *
 * @external {Events} https://developer.mozilla.org/en-US/docs/Web/API/Performance/now
 */
export default function() {
  if (t0) {
    const t1 = performance.now();
    return `${t1 - t0} milliseconds`;
  }
  return `N/A`;
}



// WEBPACK FOOTER //
// ./src/client/utils/js_execution_util.js